// @ts-nocheck

/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { isDev, isDevStaging, isLocalHost } from "utils/helpers";
import { LogLevel } from "./msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId:
      isLocalHost() || isDev() || isDevStaging()
        ? "d7538e23-17a9-4eda-a13d-9dbcb94cb384"
        : "47b2a3d8-1b31-48bd-b0f7-0088af3a9319",
    authority:
      "https://login.microsoftonline.com/4a771845-2099-4cad-af3d-17cf4244582f",
    redirectUri: window.location.origin,
    mainWindowRedirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    pollIntervalMilliseconds: 10,
    loggerOptions: {
      /**
       * Below you can configure MSAL.js logs. For more information, visit:
       * https://docs.microsoft.com/azure/active-directory/develop/msal-logging-js
       */
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            // console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      },
    },
  },
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  apiTodoList: {
    endpoint: "http://localhost:5000/api/todolist",
    scopes: {
      read: ["api://Enter_the_Web_Api_Application_Id_Here/Todolist.Read"],
      write: ["api://Enter_the_Web_Api_Application_Id_Here/Todolist.ReadWrite"],
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: [
    isLocalHost() || isDev() || isDevStaging()
      ? "api://apimla-thetaretail-dev/.default"
      : "api://apimla-thetaretail-prod/.default",
  ],
// scopes:["api://apimla-thetaretail-prod/.default"],
  grant_type: "user_impersonation",
};

export const forcastRequest =
  isLocalHost() || isDev() || isDevStaging()
    ? "https://forecast3.demandlink.com/"
    : "https://lowesforecast.skulicity.com/";

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
